module.exports = __webpack_public_path__ + "static/media/cat.36a7e008.svg";